<template>
  <div>

    <!-- Hero Section -->
    <section class="relative flex items-center pt-20 pb-20 mt-20 bgtest"
     >
      <div class="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent"></div>
      <div class="container relative px-6 mx-auto">
        <div class="max-w-2xl px-4 text-white">
          <h1 class="font-['Playfair_Display'] text-5xl font-bold mb-6">{{ $t('views.Investment.130654-0') }}</h1>
          <p class="mb-8 text-xl">{{ $t('views.Investment.130654-1') }}</p>
          <button
          @click="jumpTo(1)" 
            class="px-8 py-3 bg-primary text-white text-lg hover:bg-primary/90 transition-colors !rounded-button whitespace-nowrap">{{ $t('views.Investment.130654-2') }}</button>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.Investment.130654-3') }} -->
    <section class="py-20 overflow-hidden bg-gray-50">
      <div class="container px-6 mx-auto">
        <h2 class="font-['Playfair_Display'] text-4xl text-center mb-16">{{ $t('views.Investment.130654-3') }}</h2>
        <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div class="p-8 text-center bg-white rounded-lg shadow-lg">
            <img src="../assets/images/cd156b6ab6e1a50ba68b7559ff0a941c.jpg"
              class="object-cover w-full h-48 mb-6 rounded-lg" :alt="$t('views.Investment.130654-4')">
            <h3 class="text-2xl font-['Playfair_Display'] mb-4">{{ $t('views.Investment.130654-4') }}</h3>
            <p class="mb-6 text-gray-600">{{ $t('views.Investment.130654-5') }}</p>
            <a @click="jumpTo(1)"  class="font-medium text-primary hover:text-primary/80">{{ $t('views.Investment.130654-6') }} <i
                class="ml-2 fas fa-arrow-right"></i></a>
          </div>
          <div class="p-8 text-center bg-white rounded-lg shadow-lg">
            <img src="../assets/images/b51467f83164287366564cdf4b301a7c.jpg"
              class="object-cover w-full h-48 mb-6 rounded-lg" :alt="$t('views.Investment.130654-7')">
            <h3 class="text-2xl font-['Playfair_Display'] mb-4">{{ $t('views.Investment.130654-7') }}</h3>
            <p class="mb-6 text-gray-600">{{ $t('views.Investment.130654-8') }}</p>
            <a @click="jumpTo(1)" class="font-medium text-primary hover:text-primary">{{ $t('views.Investment.130654-6') }} <i
                class="ml-2 fas fa-arrow-right"></i></a>
          </div>
          <div class="p-8 text-center bg-white rounded-lg shadow-lg">
            <img src="../assets/images/2410b4276058855b9f246ff7d81f461b.jpg"
              class="object-cover w-full h-48 mb-6 rounded-lg" :alt="$t('views.Investment.130654-9')">
            <h3 class="text-2xl font-['Playfair_Display'] mb-4">{{ $t('views.Investment.130654-9') }}</h3>
            <p class="mb-6 text-gray-600">{{ $t('views.Investment.130654-10') }}</p>
            <a @click="jumpTo(1)" class="font-medium text-primary hover:text-primary">{{ $t('views.Investment.130654-6') }} <i
                class="ml-2 fas fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.Investment.130654-11') }} -->
    <section class="py-20 overflow-hidden">
      <div class="container px-6 mx-auto">
        <h2 class="font-['Playfair_Display'] text-4xl text-center mb-16">{{ $t('views.Investment.130654-11') }}</h2>
        <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="../assets/images/2c66f3d6f9a2cdf0fff6c7f1f57917f1.jpg"
              class="object-cover w-full h-48" :alt="$t('views.Investment.130654-12')">
            <div class="p-6">
              <h3 class="text-xl font-['Playfair_Display'] mb-2">{{ $t('views.Investment.130654-13') }}</h3>
              <p class="mb-4 text-gray-600">{{ $t('views.Investment.130654-14') }}</p>
              <div class="flex items-center justify-between mb-4">
                <span class="text-xl font-bold text-primary">{{ $t('views.Investment.130654-15') }}</span>
                <span class="text-gray-500">{{ $t('views.Investment.130654-16') }}</span>
              </div>
              <button
              @click="jumpTo(1)"
                class="w-full py-2 bg-primary text-white hover:bg-primary/90 transition-colors !rounded-button whitespace-nowrap">{{ $t('views.Investment.130654-17') }}</button>
            </div>
          </div>
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="../assets/images/42770788d89f9bf06097225d1638f335.jpg"
              class="object-cover w-full h-48" :alt="$t('views.Investment.130654-18')">
            <div class="p-6">
              <h3 class="text-xl font-['Playfair_Display'] mb-2">{{ $t('views.Investment.130654-19') }}</h3>
              <p class="mb-4 text-gray-600">{{ $t('views.Investment.130654-20') }}</p>
              <div class="flex items-center justify-between mb-4">
                <span class="text-xl font-bold text-primary">{{ $t('views.Investment.130654-21') }}</span>
                <span class="text-gray-500">{{ $t('views.Investment.130654-22') }}</span>
              </div>
              <button
                class="w-full py-2 bg-primary text-white hover:bg-primary/90 transition-colors !rounded-button whitespace-nowrap">{{ $t('views.Investment.130654-17') }}</button>
            </div>
          </div>
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="../assets/images/e80dd64b40027d1f6f70f57a61305089.jpg"
              class="object-cover w-full h-48" :alt="$t('views.Investment.130654-23')">
            <div class="p-6">
              <h3 class="text-xl font-['Playfair_Display'] mb-2">{{ $t('views.Investment.130654-24') }}</h3>
              <p class="mb-4 text-gray-600">{{ $t('views.Investment.130654-25') }}</p>
              <div class="flex items-center justify-between mb-4">
                <span class="text-xl font-bold text-primary">{{ $t('views.Investment.130654-26') }}</span>
                <span class="text-gray-500">{{ $t('views.Investment.130654-27') }}</span>
              </div>
              <button
                class="w-full py-2 bg-primary text-white hover:bg-primary/90 transition-colors !rounded-button whitespace-nowrap">{{ $t('views.Investment.130654-17') }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.Investment.130654-28') }} -->
    <section class="py-20 overflow-hidden bg-gray-50">
      <div class="container px-6 mx-auto">
        <div class="grid items-center grid-cols-1 gap-16 md:grid-cols-2">
          <div>
            <h2 class="font-['Playfair_Display'] text-4xl mb-8">{{ $t('views.Investment.130654-28') }}</h2>
            <div class="space-y-6">
              <div class="flex items-start">
                <i class="mt-1 text-xl fas fa-check-circle text-primary"></i>
                <div class="ml-4">
                  <h3 class="mb-2 text-xl font-medium">{{ $t('views.Investment.130654-29') }}</h3>
                  <p class="text-gray-600">{{ $t('views.Investment.130654-30') }}</p>
                </div>
              </div>
              <div class="flex items-start">
                <i class="mt-1 text-xl fas fa-chart-line text-primary"></i>
                <div class="ml-4">
                  <h3 class="mb-2 text-xl font-medium">{{ $t('views.Investment.130654-31') }}</h3>
                  <p class="text-gray-600">{{ $t('views.Investment.130654-32') }}</p>
                </div>
              </div>
              <div class="flex items-start">
                <i class="mt-1 text-xl fas fa-shield-alt text-primary"></i>
                <div class="ml-4">
                  <h3 class="mb-2 text-xl font-medium">{{ $t('views.Investment.130654-33') }}</h3>
                  <p class="text-gray-600">{{ $t('views.Investment.130654-34') }}</p>
                </div>
              </div>
              <div class="flex items-start">
                <i class="mt-1 text-xl fas fa-handshake text-primary"></i>
                <div class="ml-4">
                  <h3 class="mb-2 text-xl font-medium">{{ $t('views.Investment.130654-35') }}</h3>
                  <p class="text-gray-600">{{ $t('views.Investment.130654-36') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img src="../assets/images/1a23e6a59cfaa17a6fc936e89b460374.jpg"
              class="w-full rounded-lg shadow-lg" :alt="$t('views.Investment.130654-37')">
          </div>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.Investment.130654-38') }} -->
    <section class="py-20 overflow-hidden">
      <div class="container px-6 mx-auto">
        <h2 class="font-['Playfair_Display'] text-4xl text-center mb-16">{{ $t('views.Investment.130654-38') }}</h2>
        <div class="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div class="text-center">
            <div
              class="flex items-center justify-center w-16 h-16 mx-auto mb-6 text-2xl font-bold text-white rounded-full bg-primary">
              1</div>
            <h3 class="mb-4 text-xl font-medium">{{ $t('views.Investment.130654-39') }}</h3>
            <p class="text-gray-600">{{ $t('views.Investment.130654-40') }}</p>
          </div>
          <div class="text-center">
            <div
              class="flex items-center justify-center w-16 h-16 mx-auto mb-6 text-2xl font-bold text-white rounded-full bg-primary">
              2</div>
            <h3 class="mb-4 text-xl font-medium">{{ $t('views.Investment.130654-41') }}</h3>
            <p class="text-gray-600">{{ $t('views.Investment.130654-42') }}</p>
          </div>
          <div class="text-center">
            <div
              class="flex items-center justify-center w-16 h-16 mx-auto mb-6 text-2xl font-bold text-white rounded-full bg-primary">
              3</div>
            <h3 class="mb-4 text-xl font-medium">{{ $t('views.Investment.130654-43') }}</h3>
            <p class="text-gray-600">{{ $t('views.Investment.130654-44') }}</p>
          </div>
          <div class="text-center">
            <div
              class="flex items-center justify-center w-16 h-16 mx-auto mb-6 text-2xl font-bold text-white rounded-full bg-primary">
              4</div>
            <h3 class="mb-4 text-xl font-medium">{{ $t('views.Investment.130654-45') }}</h3>
            <p class="text-gray-600">{{ $t('views.Investment.130654-46') }}</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
export default {
  name: 'InvestmentPage',
  mixins: [navigation],
  
}
</script>

<style scoped>
body {
  font-family: 'Poppins', sans-serif;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #FAFAFA;
}

.bgtest{
  background-image: url('../assets/images/706cc1ffc7807d13bd8b618db0cd1721.jpg'); 
  background-size: cover; 
  background-position: center;
}
@media (max-width: 768px) {
  .video-container {
    height: 400px !important;
  }

  main {
    overflow-x: hidden;
  }
}

.video-container {
  position: relative;
  height: 600px;
  overflow: hidden;
}

.video-container video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
}

.logo {
  height: 32px;
  width: auto;
}

input {
  border: none;
  outline: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>